
import { defineComponent, PropType } from 'vue';
import { RouteLocationRaw } from 'vue-router';
import PlayButton from '@/components/global/PlayButton.vue';
import PrimaryButton from '@/components/global/PrimaryButton.vue';

export default defineComponent({
  components: { PlayButton, PrimaryButton },
  props: {
    textLeft: String,
    textMiddle: String,
    textRight: String,
    leftLink: Object as PropType<RouteLocationRaw>,
    middleLink: Object as PropType<RouteLocationRaw>,
    rightLink: Object as PropType<RouteLocationRaw>,
  },
});
